import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        channel_id        : '',
        slack_url         : '',
        channel           : '',
        notifications     : [],
        include_user_data : false,
        feedback_type     : '',
        is_disabled       : false
    },

    isConnected: function() {
        return this.get('channel_id') || this.get('slack_url') ? true : false;
    }
});